//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    border: 0;
    background-color: var(--light-1);
    border-radius: 8px;
    padding: 0;
    position: absolute;
    top: 220%;
    right: 0px;
    transform: scale(0);
    transition: 0.4s;
    opacity: 0;
    z-index: -1;
    width: 205px;
    &.opened {
        transform: scale(1);
        opacity: 1;
    }
`;
export const Item = styled.li`
    transition: 0.35s;
    cursor: pointer;
    & > a, & > div {
        padding: 15px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        text-decoration: none;
        & span {
            color: var(--light-gray-5);
            font-size: 14px;
        }
    }
    &:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }
    &:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
    }
    &:hover {
        background-color: var(--light-blue-1);
    }
    &:active {
        background-color: var(--light-blue-3);
    }
    & > a, div {
        &:hover, &:active {
            & span {
                color: var(--dark-4);
            }
        }
    }
`;